import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {AsiTable, AsiTableData} from "@asi-ngtools/lib";
import {ArianeElement, ArianeStore, ModalService} from "@digicerba/common";
import {CanalNotificationWithMessageCountDto, INotificationsWebServiceClient} from "@resources/resources";
import * as lodash from "lodash";

@Component({
  selector: 'canaux-component',
  templateUrl: './canaux.component.html',
  host: { 'class': 'page' }
})

export class CanauxComponent {

  @ViewChild('canauxDataTable') categorieTable: AsiTable<CanalNotificationWithMessageCountDto>;
  asiTableData: AsiTableData<CanalNotificationWithMessageCountDto> = new AsiTableData<CanalNotificationWithMessageCountDto>();

  constructor(private activatedRoute: ActivatedRoute, private modalService: ModalService,
    private notificationsWebServiceClient: INotificationsWebServiceClient, arianeStore: ArianeStore) {

    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.HOME",
        route: "/alertes"
      },
      {
        libelle: "ARIANE.ADMINISTRATION",
        route: "/"
      }
    ]
    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.asiTableData.results = this.activatedRoute.snapshot.data['canaux'];
  }

  // Méthode permettant d'actualiser les li
  public refreshTable(): void {
    this.categorieTable.updateData(this.asiTableData);
  }

  // Méthode d'ouverture de popin de confirmation pour la suppression d'un canal
  openModal(id: number) {
    this.modalService.openConfirmDialog("MODAL.CANAUX.SUPPRESSION_CANAUX.title", "MODAL.CANAUX.SUPPRESSION_CANAUX.message",
      "MODAL.CANAUX.SUPPRESSION_CANAUX.confirm", "MODAL.CANAUX.SUPPRESSION_CANAUX.cancel").onDialogClose().subscribe(() => {
        this.notificationsWebServiceClient.deleteCanalNotification(id).subscribe(() => {
          lodash.remove(this.asiTableData.results, function (o) {
            return o.id == id;
          });
          this.categorieTable.updateData(this.asiTableData);
        });
      });
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/canaux.component.ts